import * as React from 'react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Action } from 'redux-actions';
import { useForm } from 'react-final-form';

import { SearchFormState } from '../../../../store/reducers';
import { toggleMultiCity } from '../../../../store/segments/actions';
import { isMultiCity } from '../../../../store/segments/selectors';
import { useTheme } from '../../../../../theme';

interface StateProps {
	isMultiCity: boolean;
}

interface DispatchProps {
	toggleMultiCity: () => Action<null>;
}

type Props = StateProps & DispatchProps;

const MultiCity = memo<Props>(props => {
	const { t } = useTranslation('SearchForm');
	const { MultiCity: css } = useTheme('SearchForm');
	const onMultiCityChange = () => props.toggleMultiCity();
	const form = useForm();

	const onChange = () => {
		onMultiCityChange();
		form.reset();
	};

	return (
		<div className={css.multiCity}>
			<label className={css.label}>
				<input
					className={css.input}
					data-test-id="multi-city-toggle"
					type="checkbox"
					onChange={onChange}
					checked={props.isMultiCity}
				/>

				<span className={css.caption}>
					{t(props.isMultiCity ? 'Set simple route' : 'Set multi city route')}
				</span>
			</label>
		</div>
	);
});

const mapStateToProps = (state: SearchFormState): StateProps => {
	return {
		isMultiCity: isMultiCity(state)
	};
};

const mapDispatchToProps = {
	toggleMultiCity
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiCity);
